import { Routes, Route, Navigate } from 'react-router-dom';

import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';

import LoginPage from './pages/LoginNew';
import Dashboard from './pages/DashboardNew';
import SaasUsers from './pages/SaasUsers';
import ProspectDashboard from './pages/prospect/Dashboard';
import ProspectFollowUp from './pages/prospect/FollowUp';
import ProspectLaunched from './pages/prospect/Launched';
import ProspectMap from './pages/prospect/Map';
import ProspectSettings from './pages/prospect/Settings';
import Central from './pages/Central';
import Rede from './pages/Rede';
import RedeRompimentosPublico from './pages/rede/components/public/PublicRompimentosPage';
import Qualidade from './pages/Qualidade';
import PagamentoKiosk from './pages/PagamentoKiosk';
import KioskGuard from './components/KioskGuard/KioskGuard';
import AgendarInstalacao from './pages/public/AgendarInstalacao';

// Páginas existentes das fases anteriores
import Agendamentos from './pages/Agendamentos';
import AgendamentoMonitoramento from './pages/agendamento/Monitoramento';
import AgendamentoOrdensServico from './pages/agendamento/OrdensServico';
import AgendamentoConfiguracoes from './pages/agendamento/Configuracoes';
import Billing from './pages/Billing';
import DesignSystem from './pages/DesignSystem';
import ConfiguracoesLayout, {
  Aplicacao as ConfigAplicacao,
  TokenERP as ConfigTokenERP,
  IA as ConfigIA,
  Parametrizacao as ConfigParametrizacao,
} from './pages/Configuracoes';

function App() {
  return (
    <Routes>
      {/* Públicas */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/agendar" element={<AgendarInstalacao />} />
      {/* Mapa público de rompimentos — link compartilhável, sem login */}
      <Route path="/rede/rompimentos" element={<RedeRompimentosPublico />} />
      <Route
        path="/kiosk/pagamento"
        element={
          <KioskGuard>
            <PagamentoKiosk />
          </KioskGuard>
        }
      />

      {/* Autenticadas — todas dentro do Layout (sidebar + main) */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />

        {/* Back-compat: /saas-users redireciona pra /configuracoes/usuarios */}
        <Route path="saas-users" element={<Navigate to="/configuracoes/usuarios" replace />} />

        <Route
          path="billing"
          element={
            <ProtectedRoute requireRole={['admin', 'operator']}>
              <Billing />
            </ProtectedRoute>
          }
        />

        {/* Módulos (cada um no primeiro nível do menu — Fase 33) */}
        <Route path="central" element={<Central />} />

        {/* Rede — front do sistema externo (backend próprio, fora do Farisx) */}
        <Route path="rede" element={<Rede />} />

        {/* Qualidade — placeholder; gate de perfil ao implementar */}
        <Route path="qualidade" element={<Qualidade />} />

        {/* Agendamento — 3 sub-rotas em Módulos > Agendamento */}
        <Route
          path="agendamento"
          element={
            <ProtectedRoute requireRole={['admin', 'operator', 'monitor']}>
              <Navigate to="/agendamento/agenda" replace />
            </ProtectedRoute>
          }
        />
        <Route
          path="agendamento/agenda"
          element={
            <ProtectedRoute requireRole={['admin', 'operator', 'monitor']}>
              <Agendamentos />
            </ProtectedRoute>
          }
        />
        <Route
          path="agendamento/ordens-servico"
          element={
            <ProtectedRoute requireRole={['admin', 'operator', 'monitor']}>
              <AgendamentoOrdensServico />
            </ProtectedRoute>
          }
        />
        <Route
          path="agendamento/monitoramento"
          element={
            <ProtectedRoute requireRole={['admin', 'operator', 'monitor']}>
              <AgendamentoMonitoramento />
            </ProtectedRoute>
          }
        />
        <Route
          path="agendamento/configuracoes"
          element={
            <ProtectedRoute requireRole={['admin', 'monitor']}>
              <AgendamentoConfiguracoes />
            </ProtectedRoute>
          }
        />

        {/* Prospect — 4 sub-rotas (admin SAAS aceito via auth híbrido Fase 14a) */}
        <Route
          path="prospect"
          element={
            <ProtectedRoute requireRole={['admin', 'operator', 'gestao_vendas', 'vendedor']}>
              <Navigate to="/prospect/dashboard" replace />
            </ProtectedRoute>
          }
        />
        <Route
          path="prospect/dashboard"
          element={
            <ProtectedRoute requireRole={['admin', 'operator', 'gestao_vendas', 'vendedor']}>
              <ProspectDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="prospect/followup"
          element={
            <ProtectedRoute requireRole={['admin', 'operator', 'gestao_vendas']}>
              <ProspectFollowUp />
            </ProtectedRoute>
          }
        />
        <Route
          path="prospect/launched"
          element={
            <ProtectedRoute requireRole={['admin', 'operator', 'gestao_vendas', 'vendedor']}>
              <ProspectLaunched />
            </ProtectedRoute>
          }
        />
        <Route
          path="prospect/map"
          element={
            <ProtectedRoute requireRole={['admin', 'gestao_vendas']}>
              <ProspectMap />
            </ProtectedRoute>
          }
        />
        <Route
          path="prospect/settings"
          element={
            <ProtectedRoute requireRole={['admin', 'gestao_vendas']}>
              <ProspectSettings />
            </ProtectedRoute>
          }
        />

        {/* Configurações (nested routes — cada aba é uma rota filha) */}
        <Route
          path="configuracoes"
          element={
            <ProtectedRoute requireRole={['admin', 'operator']}>
              <ConfiguracoesLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="usuarios" replace />} />
          <Route path="usuarios" element={<SaasUsers />} />
          <Route path="aplicacao" element={<ConfigAplicacao />} />
          <Route path="token" element={<ConfigTokenERP />} />
          <Route path="ia" element={<ConfigIA />} />
          <Route path="parametrizacao" element={<ConfigParametrizacao />} />
        </Route>

        {/* Vitrine da camada de componentes (Fase B) */}
        <Route
          path="design-system"
          element={
            <ProtectedRoute requireRole={['admin', 'operator']}>
              <DesignSystem />
            </ProtectedRoute>
          }
        />

        {/* Fallback dentro do Layout: redireciona pra Dashboard */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export default App;
